<template>
  <g>
    <path
      d="M3.81 6.28024C2.67 7.90024 2 9.87024 2 12.0002C2 14.1302 2.67 16.1002 3.81 17.7202C6.23 16.9502 8 14.6802 8 12.0002C8 9.32024 6.23 7.05024 3.81 6.28024Z"
    />
    <path
      d="M20.19 6.28024C17.77 7.05024 16 9.32024 16 12.0002C16 14.6802 17.77 16.9502 20.19 17.7202C21.33 16.1002 22 14.1302 22 12.0002C22 9.87024 21.33 7.90024 20.19 6.28024Z"
    />
    <path
      d="M14 12.0002C14 8.72024 15.97 5.91024 18.79 4.67024C17.01 3.02024 14.63 2.00024 12 2.00024C9.36999 2.00024 6.98999 3.02024 5.20999 4.67024C8.02999 5.91024 9.99999 8.72024 9.99999 12.0002C9.99999 15.2802 8.02999 18.0902 5.20999 19.3302C6.98999 20.9802 9.36999 22.0002 12 22.0002C14.63 22.0002 17.01 20.9802 18.79 19.3302C15.97 18.0902 14 15.2802 14 12.0002Z"
    />
  </g>
</template>
